import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buyTicketSticky" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = ["href"]

import { TimetableWarningType } from '../../types/api';
import { AlertCard } from '../AlertCard';


export default /*@__PURE__*/_defineComponent({
  __name: 'BuyTicketSticky',
  props: {
    text: {},
    link: {},
    linkText: {},
    alertTitle: {},
    alertWarningType: {},
    showAlert: { type: Boolean },
    onClickAlert: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showAlert && _ctx.alertTitle)
      ? (_openBlock(), _createBlock(_unref(AlertCard), {
          key: 0,
          text: _ctx.alertTitle,
          "is-warning": _ctx.alertWarningType === _unref(TimetableWarningType).Warning,
          "on-click": _ctx.onClickAlert
        }, null, 8, ["text", "is-warning", "on-click"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.text), 1),
      _createElementVNode("a", {
        class: "button",
        href: _ctx.link
      }, _toDisplayString(_ctx.linkText), 9, _hoisted_3)
    ])
  ]))
}
}

})